// extracted by mini-css-extract-plugin
export default {"bread":"Bread_bread__m-6E5"};